import React from 'react';
import styles from './styles.module.scss';
import cc from 'classcat';

interface Props {
  fragment: AmenitiesBlockFragment;
}

const AmenitiesBlock = ({ fragment }: Props) => {
  const { headingTextPrimary, headingTextSecondary, headingTextTertiary, amenitiesFromCategory } = fragment;

  return (
    <div className={cc(['saSection', styles.amenitiesBlock])}>
      <div className="saContainer">
        <div className={styles.cardIntro}>
          {headingTextPrimary && (
            <p className={styles.preheading}>
              {headingTextPrimary}
            </p>
          )}

          {headingTextSecondary && (
            <h2>
              {headingTextSecondary}
            </h2>
          )}

          {headingTextTertiary && (
            <p className={styles.subheading}>
              {headingTextTertiary}
            </p>
          )}
        </div>

        {amenitiesFromCategory && amenitiesFromCategory.length > 0 && (
          <div className={styles.amenitiesGrid}>
            {amenitiesFromCategory.map((amenity) => {
              if (!amenity) return null;

              const iconUrl = (amenity as any).icon?.[0]?.url;

              return (
                <div key={amenity.id} className={styles.amenityItem}>
                  {iconUrl && (
                    <div className={styles.amenityIcon}>
                      <img src={iconUrl} alt={amenity.title || ''} />
                    </div>
                  )}
                  {amenity.title && (
                    <h3 className={styles.amenityTitle}>{amenity.title}</h3>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default AmenitiesBlock;

